var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-element"},[_c('div',{staticClass:"form-element__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.message)?_c('div',{staticClass:"form-element__message"},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }